// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__ShEtL","container":"styles_container___7FiI","title":"styles_title__3sj4n","wrapper":"styles_wrapper__1M64x","answer":"styles_answer__aScCE"};